import { render, staticRenderFns } from "./TheShareScreen.vue?vue&type=template&id=644bb9c6&"
import script from "./TheShareScreen.vue?vue&type=script&lang=js&"
export * from "./TheShareScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports